import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {
    LOAD = 'react/common/medicalExamination/LOAD',
    LOAD_PENDING = 'react/common/medicalExamination/LOAD_PENDING',
    LOAD_FULFILLED = 'react/common/medicalExamination/LOAD_FULFILLED',
    LOAD_REJECTED = 'react/common/medicalExamination/LOAD_REJECTED',

    LOADBYUSER = 'react/common/medicalExamination/LOADBYUSER',
    LOADBYUSER_PENDING = 'react/common/medicalExamination/LOADBYUSER_PENDING',
    LOADBYUSER_FULFILLED = 'react/common/medicalExamination/LOADBYUSER_FULFILLED',
    LOADBYUSER_REJECTED = 'react/common/medicalExamination/LOADBYUSER_REJECTED',

    LOADBYMEX_ID = 'react/common/medicalExamination/LOADBYMEX_ID',
    LOADBYMEX_ID_PENDING = 'react/common/medicalExamination/LOADBYMEX_ID_PENDING',
    LOADBYMEX_ID_FULFILLED = 'react/common/medicalExamination/LOADBYMEX_ID_FULFILLED',
    LOADBYMEX_ID_REJECTED = 'react/common/medicalExamination/LOADBYMEX_ID_REJECTED',

    VALIDATE = 'react/common/medicalExamination/VALIDATE',
    VALIDATE_PENDING = 'react/common/medicalExamination/VALIDATE_PENDING',
    VALIDATE_FULFILLED = 'react/common/medicalExamination/VALIDATE_FULFILLED',
    VALIDATE_REJECTED = 'react/common/medicalExamination/VALIDATE_REJECTED',

    DELETE = 'react/common/medicalExamination/DELETE',
    DELETE_PENDING = 'react/common/medicalExamination/DELETE_PENDING',
    DELETE_FULFILLED = 'react/common/medicalExamination/DELETE_FULFILLED',
    DELETE_REJECTED = 'react/common/medicalExamination/DELETE_REJECTED',

    ADD = 'react/common/medicalExamination/ADD',
    ADD_PENDING = 'react/common/medicalExamination/ADD_PENDING',
    ADD_FULFILLED = 'react/common/medicalExamination/ADD_FULFILLED',
    ADD_REJECTED = 'react/common/medicalExamination/ADD_REJECTED',

    RESETNEW = 'react/common/medicalExamination/RESETNEW',

    OTHER_ACTION = 'react/common/medicalExamination/__any_other_action__',
}

export type Types = IBaseAction<Keys>;